import * as Illustration from "@npco/zeller-design-system/illustration";

import { Layout } from "./routes/shared/layout";
import { ListSteps } from "./shared/list-steps";
import { PromptBig } from "./shared/prompt-big";

export namespace AuthenticationOperationFailure {
	export type Props = {
		onRetry?: () => void;
		onClose: () => void;
	};
}

export function AuthenticationOperationFailure(
	props: AuthenticationOperationFailure.Props,
) {
	return (
		<Layout
			logo
			onClose={props.onClose}
			actions={[
				props.onRetry && {
					label: "Try again",
					onClick: props.onRetry,
					primary: true,
				},
				{
					label: "Close",
					onClick: props.onClose,
				},
			]}
			actionsStyle="full-width"
		>
			<PromptBig
				image={<Illustration.LockedLockAndKey />}
				title="Authentication Operation Failure"
				message={
					<>
						Contact your Point of Sale support team and ensure that:
						<ListSteps
							items={[
								"Third-Party Cookies are allowed.",
								"Browser extensions are disabled or added to the allow-list if necessary.",
								"If the problem persists, please contact Zeller for further assistance.",
							]}
						/>
					</>
				}
			/>
		</Layout>
	);
}
